// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var map = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond);
var fromEnum3 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond);
var fromEnum4 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var fromEnum5 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum6 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var pad = function ($copy_v) {
    return function ($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v === 0) {
                $tco_done = true;
                return v1;
            };
            if (v === 1) {
                $tco_done = true;
                return "0" + v1;
            };
            $tco_var_v = v - 1 | 0;
            $copy_v1 = "0" + v1;
            return;
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($tco_var_v, $copy_v1);
        };
        return $tco_result;
    };
};
var padWith = function (n) {
    return function (str) {
        return pad(n - Data_String_CodePoints.length(str) | 0)(str);
    };
};
var liftEitherErr = function (dictMonadError) {
    var liftEither = Control_Monad_Error_Class.liftEither(dictMonadError.MonadThrow0());
    return function (mapErr) {
        var $33 = lmap(mapErr);
        return function ($34) {
            return liftEither($33($34));
        };
    };
};
var liftAffErr = function (dictMonadError) {
    var liftEither = Control_Monad_Error_Class.liftEither(dictMonadError.MonadThrow0());
    return function (dictMonadAff) {
        var bind = Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1());
        var liftAff = Effect_Aff_Class.liftAff(dictMonadAff);
        return function (mapErr) {
            return function (io) {
                return bind(liftAff(map(lmap(mapErr))(io)))(liftEither);
            };
        };
    };
};
var dateTimeToStringISO8601 = function (v) {
    var encodeTime = function (t) {
        return padWith(2)(show(fromEnum(Data_Time.hour(t)))) + (":" + (padWith(2)(show(fromEnum1(Data_Time.minute(t)))) + (":" + (padWith(2)(show(fromEnum2(Data_Time.second(t)))) + ("." + (show(fromEnum3(Data_Time.millisecond(t))) + "Z"))))));
    };
    var encodeDate = function (d) {
        return padWith(4)(show(fromEnum4(Data_Date.year(d)))) + ("-" + (padWith(2)(show(fromEnum5(Data_Date.month(d)))) + ("-" + padWith(2)(show(fromEnum6(Data_Date.day(d)))))));
    };
    return encodeDate(v.value0) + ("T" + encodeTime(v.value1));
};
export {
    dateTimeToStringISO8601,
    liftAffErr,
    liftEitherErr,
    padWith
};
//# sourceMappingURL=index.js.map
